import { Spinner } from "@/components/kit";
import { useAdminQuery } from "@/hooks/queries";
import { AdminHeader, StatCard } from "@/pages/admin/AdminLayout";

export default function AdminDashboard() {
  const { data: d, isLoading, error } = useAdminQuery("/admin/dashboard");
  if (isLoading) return <Spinner />;
  if (error) return <p className="text-[#DC2626]">{error.message}</p>;
  const rev = d.revenueRupees ?? (d.revenuePaise != null ? d.revenuePaise / 100 : null);
  return (
    <>
      <AdminHeader title="Dashboard" sub="A snapshot of TOTO right now." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-testid="admin-dashboard-stats">
        <StatCard label="Total users" value={d.totalUsers} testid="stat-total-users" />
        <StatCard label="Active users" value={d.activeUsers} accent="#059669" testid="stat-active-users" />
        <StatCard label="Premium users" value={d.premiumUsers} accent="#7C3AED" testid="stat-premium-users" />
        <StatCard label="Free users" value={d.freeUsers ?? (d.totalUsers - d.premiumUsers)} accent="#2563EB" testid="stat-free-users" />
        <StatCard label="Suspended" value={d.suspendedUsers} accent="#DC2626" testid="stat-suspended" />
        <StatCard label="New users (7d)" value={d.newUsers7d} accent="#EA580C" testid="stat-new-users" />
        <StatCard label="Total contacts" value={d.totalContacts} testid="stat-contacts" />
        <StatCard label="Total scans" value={d.totalScans} testid="stat-scans" />
        {d.totalEvents != null && <StatCard label="Total events" value={d.totalEvents} testid="stat-events" />}
        <StatCard label="Revenue" value={rev != null ? `₹${Number(rev).toLocaleString("en-IN")}` : "—"} accent="#059669" testid="stat-revenue" />
        {d.paidOrders != null && <StatCard label="Paid orders" value={d.paidOrders} testid="stat-paid-orders" />}
      </div>
    </>
  );
}
